import { useState } from "react";
import getConfig from "src/analyticsProvider/index";
import { trackPageInteraction } from "asos-contentweb-analytics-middleware";
import updatePageNumberQueryParamSearchList from "src/utilities/updatePageNumberQueryParamSearchList";
import fetchSearches from "src/utilities/fetchSearches";
import noticeError from "src/app/utilities/noticeError";

const useSearchProvider = ({
  currentPage: initialCurrentPage,
  query: queryStringSearch,
  itemCount: faqTotal = "0",
  items: initialItems = [],
  pageSize,
  storeData,
}) => {
  const [searches, setSearches] = useState(initialItems);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(initialCurrentPage);
  const [visitedPages, setVisitedPages] = useState([initialCurrentPage]);
  const [itemToFocus, setItemToFocus] = useState(null);

  const maxPageCount = Math.ceil(faqTotal / pageSize);
  const prevButtonIsActive = !visitedPages.includes(0) && currentPage + 1 > 1;
  const nextButtonIsActive =
    !visitedPages.includes(maxPageCount - 1) && currentPage + 1 < maxPageCount;

  const [fixedErrorVisible, setFixedErrorVisible] = useState(false);
  const [failedDirection, setFailedDirection] = useState("");

  const onNextButtonClick = async (event) => {
    event.preventDefault();
    const updatedPageNextPosition = currentPage + 1;
    await loadSearches(
      updatedPageNextPosition * 12,
      updatedPageNextPosition,
      "next",
      updatedPageNextPosition + 1 // pages are 0 indexed
    );
  };

  const onPreviousButtonClick = async (event) => {
    event.preventDefault();
    const updatedPagePrevPosition = currentPage - 1;
    await loadSearches(
      updatedPagePrevPosition * 12,
      updatedPagePrevPosition,
      "prev",
      currentPage === 0 ? 1 : currentPage
    );
  };

  const loadSearches = async (
    searchIndex,
    pageNumber,
    buttonDirection,
    queryStringPage
  ) => {
    setFixedErrorVisible(false);
    setFailedDirection("");
    setLoading(true);
    try {
      const response = await fetchSearches(
        queryStringSearch,
        storeData,
        pageSize,
        searchIndex
      );
      const results =
        buttonDirection === "next"
          ? [...searches, ...response.results]
          : [...response.results, ...searches];
      setSearches(results);
      setItemToFocus(
        results.findIndex((item) => item.title === response.results[0].title)
      );
      setCurrentPage(pageNumber);
      setVisitedPages([...visitedPages, currentPage]);
      updatePageNumberQueryParamSearchList(queryStringPage, queryStringSearch);
      sendAnalytics(queryStringPage, buttonDirection);
    } catch (err) {
      setFixedErrorVisible(true);
      setFailedDirection(buttonDirection);
      noticeError(err);
    } finally {
      setLoading(false);
    }
  };

  const sendAnalytics = (newPage, direction) => {
    const configName =
      direction === "next"
        ? "search-results-load-next"
        : "search-results-load-previous";
    const loadMoreConfig = getConfig(configName, {
      pageNumber: newPage,
    });
    trackPageInteraction(loadMoreConfig);
  };

  return {
    searches,
    currentPage,
    prevButtonIsActive,
    nextButtonIsActive,
    onPreviousButtonClick,
    onNextButtonClick,
    itemToFocus,
    loading,
    fixedErrorVisible,
    failedDirection,
  };
};

export default useSearchProvider;
